const shenqing = [{
    name: '初期准备',
    child: [{
        name: '留学评估',
        link: 'http://liuxue.xdf.cn/Evaluation/'
    },{
        name: '留学答疑',
        link: 'http://liuxue.xdf.cn/dydt'
    }]
},{
    name: '留学方案',
    child: [{
        name: '去读研究生',
        link: 'http://liuxue.xdf.cn/Postgraduate/'
    },{
        name: '去读本科',
        link: 'http://liuxue.xdf.cn/Undergraduate/'
    },{
        name: '去读初高中',
        link: 'http://liuxue.xdf.cn/highschool/'
    }]
},{
    name: '语言备考',
    child: [{
        name: '托福',
        link: 'http://toefl.xdf.cn'
    },{
        name: '雅思',
        link: 'http://ielts.xdf.cn'
    },{
        name: 'SAT',
        link: 'http://sat.xdf.cn'
    },{
        name: 'ACT',
        link: 'http://act.xdf.cn'
    },{
        name: 'GRE',
        link: 'http://gre.xdf.cn'
    },{
        name: 'GMAT',
        link: 'http://gmat.xdf.cn'
    }]
},{
    name: '院校选择',
    child: [{
        name: '海外院校库',
        link: 'http://hutuyu.cn/?utm_source=jituanguanwang&utm_medium=goabroad&utm_term=timeline&utm_content=timeline&utm_campaign=timeline'
    },{
        name: '海外院校排名',
        link: 'http://goabroad.xdf.cn/zhuanti/universityrankings/index.html'
    }]
},{
    name: '材料准备',
    child: [{
        name: '美国研究生背景提升',
        link: 'http://liuxue.xdf.cn/special/usa/postgraduate_bjts/'
    },{
        name: '英国申请背景提升',
        link: 'http://liuxue.xdf.cn/special/uk/2016_uk_dream/'
    },{
        name: '德国审核面试',
        link: 'http://liuxue.xdf.cn/special/eur/aps/'
    }]
},{
    name: '留学签证',
    child: [{
        name: '签证指导',
        link: 'http://liuxue.xdf.cn/visa/'
    },{
        name: '美研签证',
        link: 'http://liuxue.xdf.cn/special/usa/Postgraduate_visa/'
    }]
},{
    name: '行前准备',
    child: [{
        name: '行前攻略',
        link: 'http://liuxue.xdf.cn/special/news/abroad/'
    },{
        name: '行前准备',
        link: 'http://goabroad.xdf.cn/list_2579_1.html'
    }]
},{
    name: '成功留学',
    child: [{
        name: '后续服务',
        link: 'http://liuxue.xdf.cn/special/qt_houxu/'
    }]
}]
export { shenqing }


// WEBPACK FOOTER //
// ./src/api/js/gobroad/shenqingliucheng.js